import { SheetContext, useSheetContext } from "@/context/sheet";
import { Outlet, useNavigate } from "@tanstack/react-router";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { NavActions } from "../nav-actions";
import { Skeleton } from "../ui/skeleton";
import { ReactNode } from "react";

interface DomainSheetProps {
  onClose?: () => Promise<void> | void;
  noOutlet?: boolean;
  children?: ReactNode;
}

export function DomainSheet(props: DomainSheetProps) {
  return (
    <SheetContext>
      <SheetComponent {...props} />
    </SheetContext>
  );
}

function SheetComponent({ onClose, children, noOutlet }: DomainSheetProps) {
  const { close, open, isLoading, title, titleExtras } = useSheetContext();
  const navigate = useNavigate();
  return (
    <Sheet
      open={open}
      onOpenChange={(o) => {
        if (!o) close(onClose ?? (() => navigate({ to: ".." })));
      }}
    >
      <SheetContent className="overflow-y-auto">
        <SheetHeader>
          <SheetTitle>
            {isLoading ? <Skeleton className="h-7 w-7" /> : title}
          </SheetTitle>
          {titleExtras?.length ? (
            <div>
              <NavActions items={titleExtras} />
            </div>
          ) : (
            <></>
          )}
        </SheetHeader>
        {noOutlet ? <></> : <Outlet />}
        {children}
      </SheetContent>
    </Sheet>
  );
}
